@if (isStarting()) {
  <app-page-loader message="Iniciando o desafio" />
} @else if (theme()) {
  <div class="relative flex w-full flex-grow flex-col items-center justify-center px-container-padding-mobile py-4">
    <div class="w-full max-w-sm">
      <app-date-picker
        [min]="minDate"
        [max]="maxDate"
        [today]="maxDate"
        [dayClass]="dayClass()"
        [value]="selectedDate()"
        (daySelect)="onDaySelect($event)"
      />

      <!-- Mensagem fora do fluxo do layout: não empurra o calendário nem gera scroll -->
      <p class="relative h-0 w-full text-center font-label-mono text-label-mono uppercase tracking-widest" aria-live="polite">
        @if (errorMessage(); as message) {
          <span class="absolute inset-x-0 top-3 text-error">{{ message }}</span>
        }
      </p>
    </div>
  </div>

  <app-back-button (click)="onBackClick()" />
}

@if (showAlreadyPlayedAlert()) {
  <app-alert-modal [message]="alreadyPlayedMessage" (close)="showAlreadyPlayedAlert.set(false)" />
}
